// removed by extract-text-webpack-plugin
module.exports = {"container":"src-page-components-glass-detail-header----styles-module---container---2DBk8","back":"src-page-components-glass-detail-header----styles-module---back---1_V0_","heading":"src-page-components-glass-detail-header----styles-module---heading---TeKCU"};


//////////////////
// WEBPACK FOOTER
// ./src/page-components/glass-detail/header/styles.module.css
// module id = 647
// module chunks = 99110987824835